export default class ModalMenuLanguage {
    constructor($el) {
        this.$el = $el;
        this.$btn = this.$el.querySelector('[data-modal-trigger]');
        this.$modal = this.$el.querySelector('[data-modal]');
        this.$modalContainer = this.$el.querySelector('[data-modal-container]');
        this.$mouseOver = false;
        this.$collapsableItem = this.$el.querySelector('[data-collapsable-item]');
        this.isXL = window.innerWidth >= 1200;

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleCollapsable = this.toggleCollapsable.bind(this);
        // this.goToLink = this.goToLink.bind(this);

        this.$el.addEventListener('mouseover', this.showModal);

        this.$btn.addEventListener('click', this.showModal);

        // if( ! this.isXL) {
        //     this.$el.addEventListener('click', this.toggleCollapsable);
        // }

        if( ! this.$modal) {
            return;
        }

        if( ! this.$modalContainer) {
            return;
        }

        this.$modal.addEventListener('mouseover', (e) => {
            this.$mouseOver = true;
        })

        if(this.$modal !== null)
        {

            this.$modalContainer.addEventListener('mouseleave', (e) => {
                this.$mouseOver = false;
                this.closeModal();
            });

            this.$el.addEventListener('mouseleave', (e) => {
                setTimeout(this.closeModal, 300);
            });
        }
    }

    showModal(e) {
        e.preventDefault();
        if( ! this.$modalContainer) {
            return;
        }
        this.$modalContainer.classList.add('modal__container--open');
        this.$modal.classList.add('modal--open');
    }

    closeModal() {
        if( ! this.$mouseOver) {
            this.$modalContainer.classList.remove('modal__container--open');
            this.$modal.classList.remove('modal--open');
        }
    }

    toggleModal(e) {
        if( ! this.$modalContainer.classList.contains('modal__container--open')) {
            this.$modalContainer.classList.add('modal__container--open');
            this.$modal.classList.add('modal__container--open');
            return;
        }
        this.$modalContainer.classList.remove('modal__container--open');
        this.$modal.classList.remove('modal__container--open');
    }

    toggleCollapsable(e) {
        e.preventDefault();
        if( ! this.$collapsableItem) {
            window.location.href = e.target.href;
        }
        this.$collapsableItem.classList.toggle('collapsable__item__text--open')
    }
}